import { ref } from "vue";
import { COUNTRIES } from "@/helpers/countries";

interface useStateType {
  selectedCities: { name?: string; value?: [] };
  getCities: (country: string, state: string) => void;
}

interface ICity {
  name: string;
  state: string;
}

export function useCity(): useStateType {
  const selectedCities = ref();
  let cities: ICity[] = [];

  const getCities = (country, state) => {
    cities = COUNTRIES[country]?.cities.filter((city) => city.state === state);
    if (cities.length > 0) {
      cities = cities.sort((c1: ICity, c2: ICity): number => {
        return c1.name > c2.name ? 1 : c1.name < c2.name ? -1 : 0;
      });
    }

    selectedCities.value = cities.map((city) => {
      return {
        name: city.name,
      };
    });
  };

  return {
    selectedCities,
    getCities,
  };
}
